export default "__VITE_ASSET__KUidPa1z__"